export default {
  test: function(Num) {
    //判断号码是否存在
    if (!Num || Num == null) {
      return false;
    }
    // 判断号码前是否带0
    if (Num.substring(1, 0) == 0) {
      var phone = Num.substring(4, 0);
      phone = phone.replace("0", "");
      var len = phone.length;
    } else {
      var phone = Num.substring(3, 0);
      var len = phone.length;
    }
		let rules = JSON.parse(localStorage.getItem('site_rules'));
    let globe = /^(817|90[5|6]|91[5|6|7]|92[6|7]|93[5|6|7]|945|95[3|4|5|6]|96[5|6|7]|97[3|5|6|7|8|9]|99[5|6|7])\d{0}$/;
    let smart = /^(813|90[7|8|9]|91[0|1|2|3|4|8|9]|92[0|1|8|9]|93[0|1|8|9]|94[0|1|6|7|8|9]|95[0|1|7|8|9]|96[0|1|2|3|4|8|9]|97[0|1]|98[0|1|2|5|9]|99[8|9])\d{0}$/;
    let dito = /^(99[1|2|3|4]|89[5|6|7|8])\d{0}$/;
    let sun = /^(92[2|3|4|5]|93[2|3|4]|94[2|3|4]|952|97[1|2])\d{0}$/;
		if (rules) {
      globe = new RegExp(rules.globe);
      smart = new RegExp(rules.smart);
      dito = new RegExp(rules.dito);
      sun = new RegExp(rules.sun);
		}

    if (phone.match(globe) && phone.length == 3 && len == 3) {
      return 1;
    }
    if (phone.match(smart) && phone.length == 3 && len == 3) {
      return 2;
    }
    if (phone.match(dito) && phone.length == 3 && len == 3) {
      return 3;
    }
    if (phone.match(sun) && phone.length == 3 && len == 3) {
      return 4;
    }
    return false;
  },
}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 